module.exports = __webpack_public_path__ + "static/media/mob17.04f0bedf.jpeg";